import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useTour } from "hooks/useTour";

import Item from "./Item";

import BillCompensationBanner from "components/BillCompensationBanner";
import TourBalloon from "components/NewTour/TourBallon";
import {
  BillCompensationWrapper,
  Button,
  ContainerWrap,
  ContentBody,
  ContentButton,
  ContentCard,
  HeaderCard,
  NotBills,
  TitleCard,
} from "./styles";

type BillsProps = {
  data: any;
};

const Bills = ({ data }: BillsProps): JSX.Element => {
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );

  const { showTour, tourStep, tourType } = useTour();

  return (
    <ContentCard showTour={tourStep === 8 && tourType === "home" && showTour}>
      <ContainerWrap>
        <HeaderCard>
          <TitleCard>Boletos</TitleCard>
          <BillCompensationWrapper>
            <BillCompensationBanner />
          </BillCompensationWrapper>
        </HeaderCard>
        <ContentBody>
          {data?.length ? (
            data?.map((item) => <Item key={item?.invoice?.id} data={item} />)
          ) : (
            <NotBills>Você não possui boletos!</NotBills>
          )}
          {!selectedUnit?.hasCurrentHouseholder && (
            <ContentButton>
              <Button to="boletos">
                <span>Ver todos</span>
                <FiArrowRight />
              </Button>
            </ContentButton>
          )}
        </ContentBody>
        {showTour && tourStep === 8 && tourType === "home" && (
          <TourBalloon
            title="Boletos"
            content="Aqui você encontra, de forma resumida, o histórico dos últimos boletos. Ao clicar em <span class='mdi mdi-dots-vertical'></span> você poderá ver os detalhes do boleto, baixar o arquivo ou ainda enviar por e-mail."
            position={{
              right: "-368px",
              top: "128px",
              arrowPosition: "left",
              maxWidth: 320,
              arrowLeft: "-10%",
            }}
          />
        )}
      </ContainerWrap>
    </ContentCard>
  );
};

export default Bills;
